"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnalyticsTracker = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireWildcard(require("react"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var initialize = function initialize(trackingId, options) {
  if (!trackingId) {
    console.warn('trackingId cannot be `null` for function initialize()');
    return;
  }

  if (!options) {
    console.warn('Options cannot be `null` for function initialize()');
    return;
  }

  _reactGa.default.initialize(trackingId, {
    debug: false,
    titleCase: false
  });

  window.BHGAnalytics = (0, _objectSpread2.default)({}, options);
};

var event = function event(_event) {
  if (!_event.category) {
    console.warn('category cannot be `null` for function event()');
    return;
  }

  _reactGa.default.event((0, _objectSpread2.default)({}, _event));
};

var AnalyticsTracker = function AnalyticsTracker(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = window.BHGAnalytics || {},
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? '' : _ref$prefix;

  var trackPage = function trackPage(page) {
    if (process.env.NODE_ENV !== 'development') {
      _reactGa.default.set((0, _objectSpread2.default)({
        page: page
      }, options));

      _reactGa.default.pageview(prefix + page);

      if (window.fbq) window.fbq('track', 'PageView');
    }
  };

  var HOC = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(HOC, _Component);

    var _super = (0, _createSuper2.default)(HOC);

    function HOC() {
      (0, _classCallCheck2.default)(this, HOC);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var page = this.props.location.pathname;
        trackPage(page);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var currentPage = this.props.location.pathname;
        var nextPage = nextProps.location.pathname;

        if (currentPage !== nextPage) {
          trackPage(nextPage);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
      }
    }]);
    return HOC;
  }(_react.Component);

  return HOC;
};

exports.AnalyticsTracker = AnalyticsTracker;
var _default = {
  initialize: initialize,
  event: event
};
exports.default = _default;